/*
    This is our superagent wrapper for redux-saga and redux-requests
    ADD MORE DOCS TODO
*/

import { IndexableObjectType } from "component-library-and-tools/dist/types/commonTypes";
import { DefaultHeadersObject } from "./request-utils";

// The data and some more params, if not in use by Oct 2020 delete.
const prepareSuccessPayload = (response: any) => ({
  data: response.body,
  status: response.status,
  error: response.error,
  statusText: response.statusText,
});

// Just the data
const prepareSimpleSuccessPayload = (response: any) => response.body;


export const createDebugDriver = {}; // TODO Make a verbose driver

/**
 * TODO: In use for Redux-Saga-Requests, remove if not in use by Oct 2020
 * @param superagentInstance 
 */
export const createReduxSagaRequestsDriver = (superagentInstance: any) => ({
    requestInstance: superagentInstance,
    getAbortSource() {
        return superagentInstance.agent();
    },
    abortRequest() {
        superagentInstance.abort();
    },
    sendRequest(requestConfig: any) {
        const {url, method = 'GET'} = requestConfig;
        
        return superagentInstance(method, url);

    },
    getSuccessPayload(response: any) {
        if (Array.isArray(response)) {
          return response.map(prepareSuccessPayload);
        }
    
        return prepareSuccessPayload(response);
      },
      getErrorPayload(error: any) {
        return error;
      },
});

/**
 * Creates the wrapper for superagent to be used by Redux-Requests
 * @param superagentInstance 
 */
export const createDriver = (superagentInstance: any) => (requestConfig: any) => {
  const {
    url,
    method = 'GET',
    headers = {},
    body,
  } = requestConfig;

  superagentInstance.cancel = superagentInstance.abort;

  return superagentInstance(method, url)
    .set({
      ...DefaultHeadersObject.get(),
      ...headers,
    })
    .send(body)
    .then(prepareSimpleSuccessPayload);
};
